import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './src/BlogOverview/BlogOverview';
import './src/ProductOverview/ProductOverview';
import { Provider } from 'react-redux';
import store from './src/redux-modules/store';
import ProductDetail from './src/ProductDetail/ProductDetail';
import SessionContainer from './src/Containers/SessionContainer';

const productDetail = document.getElementById('product-detail') as HTMLElement;
const productDetailSettings = productDetail?.dataset as
  { productId: string, productUri: string, color: string } | null;
if (productDetail && productDetailSettings) {
  const { productId, productUri, color } = productDetailSettings;
  const router = createBrowserRouter([
    {
      path: productUri,
      element: <ProductDetail productId={productId} color={color} type="full" />,
    },
  ]);
  ReactDOM.createRoot(productDetail).render(
    <React.StrictMode>
      <Provider store={store}>
        <SessionContainer>
          <RouterProvider router={router} />
        </SessionContainer>
      </Provider>
    </React.StrictMode>,
  );
}

const productSmallDetail = document.getElementById('product-small-detail') as HTMLElement;
const productSmallDetailSettings = productSmallDetail?.dataset as
  { productId: string, color: string } | null;
if (productSmallDetail && productSmallDetailSettings) {
  const { productId, color } = productSmallDetailSettings;
  const router = createBrowserRouter([
    {
      path: window.location.pathname,
      element: <ProductDetail productId={productId} color={color} type="small" />,
    },
  ]);
  ReactDOM.createRoot(productSmallDetail).render(
    <React.StrictMode>
      <Provider store={store}>
        <SessionContainer>
          <RouterProvider router={router} />
        </SessionContainer>
      </Provider>
    </React.StrictMode>,
  );
}
